export const ibpDefaultFields = [
  'sector',
  'market',
  'reports',
  'gdoStatus',
  'stageName',
];
